import { useState } from "react";

import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCurrentDrawer } from "client/common/hooks/stackables";

import { useClientUserQuery, useUpdateProfileMutation } from "../../hooks";
import TextInput from "../../../common/components/inputs/TextInput";

export type AccountUpdateEmailDrawerProps = {
  isProfileContext?: boolean;
};

const AccountUpdateEmailDrawer = ({ isProfileContext = false }: AccountUpdateEmailDrawerProps) => {
  const { data: clientUser, isLoading, error } = useClientUserQuery();
  const { close } = useCurrentDrawer();
  const [emailAddress, setEmailAddress] = useState(clientUser?.primary_contact_email?.email || "");

  const {
    mutate: updateProfile,
    isPending: isUpdating,
    error: updateError,
  } = useUpdateProfileMutation({ onSuccess: close });

  if (isLoading) {
    return <DrawerLayout.Loading />;
  }

  if (!clientUser || error) {
    return <DrawerLayout.FetchError error={error} entityName="account" />;
  }
  const title = isProfileContext ? "Update profile email" : "Update email";
  const submitText = isProfileContext ? "Update profile email" : "Update email";

  return (
    <DrawerLayout>
      <DrawerLayout.Header title={title} onClose={close} />
      <DrawerLayout.Form
        submitText={submitText}
        canSubmit={!isLoading && !isUpdating}
        onSubmit={() => updateProfile({ email: emailAddress })}
        error={updateError}
      >
        <DrawerLayout.Form.Group>
          <TextInput
            value={emailAddress || ""}
            label="Email Address"
            onChange={setEmailAddress}
            errors={updateError?.errors.email}
          />
        </DrawerLayout.Form.Group>
      </DrawerLayout.Form>
    </DrawerLayout>
  );
};

export default AccountUpdateEmailDrawer;
